module.exports = __webpack_public_path__ + "static/shape-group-1-79ef1682172fbd33df1baffefc5e5142.svg";